import { createSlice, PayloadAction } from "@reduxjs/toolkit";

/** A master lookup option (rep type, commission structure, or trigger). */
export interface SalesRepMasterOption {
  id: string;
  name: string;
  description?: string;
  isdefaultSelected?: boolean;
}

export interface SalesRepMasterState {
  repTypes: SalesRepMasterOption[];
  commissionStructures: SalesRepMasterOption[];
  commissionTriggers: SalesRepMasterOption[];
  /** True once the master data has been fetched, so it is only loaded once per session. */
  loaded: boolean;
}

const initialState: SalesRepMasterState = {
  repTypes: [],
  commissionStructures: [],
  commissionTriggers: [],
  loaded: false,
};

const salesRepMasterSlice = createSlice({
  name: "salesRepMaster",
  initialState,
  reducers: {
    setSalesRepMaster(
      state,
      action: PayloadAction<Partial<Omit<SalesRepMasterState, "loaded">>>
    ) {
      state.repTypes = action.payload.repTypes ?? [];
      state.commissionStructures = action.payload.commissionStructures ?? [];
      state.commissionTriggers = action.payload.commissionTriggers ?? [];
      state.loaded = true;
    },
  },
});

export const { setSalesRepMaster } = salesRepMasterSlice.actions;

export default salesRepMasterSlice.reducer;
